// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Styles
import './SearchResults.sass';
import './ResultSingleItem.sass';

// Components
import MvIcon from "Generic/MvIcon";
import ResortResult from "Interfaces/ResortResultInterface";
import ToolTip from "Generic/ToolTip";
import { EXEC_MODE } from "cfg";
import { ReactAppMode } from "Interfaces/ReactAppModes";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

export interface Props {
  result: ResortResult;
  filtered : boolean;
  onRemoveItem:(propertyCode: string) => void;
  showAvailability:(waitListToggleChecked: boolean)=>void;
  openModal: () => void;
  pointsSearch ?: string;
}

class ResultSingleItem extends React.Component<Props, {}> {

  constructor(props:Props) {
    super(props);
    this.removeItem = this.removeItem.bind(this);
    this.showAvailability = this.showAvailability.bind(this);
    this.propCodeModal = this.propCodeModal.bind(this)
    this.abbreviateToUSA = this.abbreviateToUSA.bind(this);
  }

// Abbreviate country to "USA" if it's "United States"
  abbreviateToUSA(str:string){
    if (str === 'United States') return 'USA'
      return str
      }
  removeItem() {
    this.props.onRemoveItem(this.props.result.propertyCode);
  }
  showAvailability(waitListToggleChecked: boolean){
    this.props.showAvailability(waitListToggleChecked);
  }
  propCodeModal(boolean:boolean, propCode:string) {
    this.props.openModal();
  }

  handleShowAvailability = () => {
    /** 
     * PWAS analytics on Check Availability
     */
    logAnalyticData({ event: 'Select Availability', siteSection: 'Points Reservation', pageName:'Book My Holiday', website:'' }, {
      step:'Step 3:Select Availability',
      errorMessagfe:"",
      notificationType: "",
      errorMessage:"",
      resortID:this.props.result.propertyCode,
      typeofSearch:"",
      customerID:"",
      filtersApplied: "" // TODO: Populate the data
  })
    trackAnalyticData('points:step3');
  }

  render() {
    const { localize } = this.context;
    let content;
    const country = this.abbreviateToUSA(this.props.result.country);

    let showPointsAvailable:boolean = true;

    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
      showPointsAvailable = process.env.REACT_APP_POINTS_SEARCH === 'TRUE';
      showPointsAvailable = String(process.env.REACT_APP_POINTS_SEARCH) === String('TRUE');
    }
    else {
      // VCAP
      showPointsAvailable = String(this.props.pointsSearch) === String('TRUE');
    }

    // const showPointsAvailable: boolean = String(process.env.REACT_APP_POINTS_SEARCH || 'TRUE') === 'TRUE';

    const isPulseResort = this.props.result.name && this.props.result.name.toLowerCase().indexOf('pulse') !== -1;

    if (!this.props.result.available[0]) {
      content = (
        <React.Fragment>
          <div className="unavailable-content">
            <div className="unavailable-hotel-info-wrapper">
                <button id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
                <p id={`ua_${this.props.result.propertyCode.toLowerCase()}`} className="unavailable-date">
                    {this.props.result.resortLocation}
             
                </p>
            </div>
              <div className="unavailable-room-types-wrapper text-align-right">
                <p className="unavailable">{localize("static.content.unavailable")}</p>
              </div>
          </div>
        </React.Fragment>
      );
      // if (!this.props.result.unavailable[0]) {
      //   //Available and unavailable not present in the response
        
      // }
      // else {
      //   //Available is not present but unavailable is present in reposnse
      //   let activity = this.props.result.activities.map(activity => {
      //     let url = `common/cms/mvc/vcap/img/activityIcons/${activity.iconURL}.png`;
      //     return (
      //       <div key={url} className="icon">
      //         <img className="activity-icon" src={url} alt=""/>
      //         <p className="activity-icon-text">{activity.iconURL}</p>
      //       </div>
      //     );
      //   });
      //   content = (
      //     <React.Fragment>
      //       <div className="hotel-info-wrapper">
      //         <div className="resort-image btn-wrapper">
      //           <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="img-btn">
      //             <img className="resort-result-image" src={this.props.result.resortImage} alt=""/>
      //           </button>
      //         </div>
      //         <div className="eight columns resort-name">
      //           <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
      //           <p className="address-line">
      //             {this.props.result.city}, {(this.props.result.state && this.props.result.state != "NO-STATE") ? `${this.props.result.state},`  : "" }{" "}
      //             {country}
      //           </p>
      //           {activity}
      //         </div>
      //       </div>
      //       <div className="room-types-wrapper">
      //         <div className="points room-types-section">
      //           <div className="six columns points">
      //             <p style={{fontWeight:"bold" ,paddingLeft:"4px"}}>{localize("static.content.waitlist-room-types")} </p>

      //             {(this.props.result.unavailable || []).map((room, i) => {
      //               return (
      //                 <span className="rm-type" key={i}>
      //                  <span>{room.display}</span>
      //                   { i < this.props.result.unavailable.length - 1 && ' | '}
      //                 </span>
      //               );
      //             })}
      //           </div>
      //           <div className="six columns text-align-right">
      //             <p className="unavailable">{localize("static.content.unavailable")}</p>
      //             <div className="waitlist-button">
      //               <button className="form-action-button mv-button secondary" type="button">
      //                 {localize("static.content.waitlist")}
      //               </button>
      //             </div>
      //           </div>
      //         </div>
      //       </div>
      //     </React.Fragment>
      // );
      // }
    } else if (this.props.filtered) {
      // Not available based on filter
      content = (
        <React.Fragment>
          <div className="twelve columns">
            <div className='unavail-container'>
              <div className="six columns">
                <button id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
                <p id={`uaf_${this.props.result.propertyCode.toLowerCase()}`}  className="unavailable-date-filter">
                    {this.props.result.resortLocation}
              
                </p>
              </div>
            </div>
            <div className="unavail-wrapper">
              <p className="unavailable">{localize("static.content.unavailable-based-on-filters")}</p>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      // Available and Unavailable presenet in response
      let activity = this.props.result.activities.map(activity => {
        let url = activity.iconURL;
        return (
          <div key={url} className="icon">
            <img className="activity-icon" src={url} alt=""/>
            <p className="activity-icon-text">{activity.name}</p>
          </div>
        );
      });
      content = (
        <React.Fragment>
          <div className="hotel-info-wrapper">
            <div className="resort-image btn-wrapper">
              <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="img-btn">
                <img className={`resort-result-image ${isPulseResort ? 'is-pulse-resort' : ''}`} src={this.props.result.resortImage} alt=""/>
              </button>

            </div>
            <div className="eight columns resort-name">
              <button data-id={this.props.result.propertyCode.toLowerCase()} onClick={(e)=>this.propCodeModal(true, this.props.result.propertyCode)} className="rn-btn">{this.props.result.name}</button>
              <p className="address-line">
                {this.props.result.city}, {(this.props.result.state && this.props.result.state != "NO-STATE") ? `${this.props.result.state},`  : "" }{" "}
                {country}
              </p>
              {activity}
            </div>
          </div>
          <div className="room-types-wrapper">
            <div className="room-types-section">
              <div className="nine columns points">
              <p style={{fontWeight:"bold", paddingLeft:"4px", color: "#5F5F5F",fontFamily:"Arial" }}>{showPointsAvailable ? localize('static.content.points-starting') : localize("static.content.villas-available")}: </p>
                  <div>
                    {
                      showPointsAvailable ? 
                      this.props.result.available.map((room, i) => {
                        return (
                          <div className="rm-type" key={i}>
                            <span>{room.display}</span>
                            : <span>{room.pointsAmount}</span>
                            { i < this.props.result.available.length - 1 && ' | '}
                          </div>
                        );
                      })
                      :
                      this.props.result.available.map((room, i) => {
                        return (
                          <><div className="rm-type" key={i}>
                            <span>{room.display}</span>
                            {/* : <span>{room.pointsAmount}</span> */}
                            {/* { i < this.props.result.available.length - 1 && ' <br/> '} */}
                          </div>{ i < this.props.result.available.length - 1 && <br/>}</>
                        );
                      })
                    }
                    {/*this.props.result.available.map((room, i) => {
                      return (
                        <><div className="rm-type" key={i}>
                          <span>{room.display}</span>
                          {/* : <span>{room.pointsAmount}</span> */}
                          {/* { i < this.props.result.available.length - 1 && ' <br/> '} }
                        </div>{ i < this.props.result.available.length - 1 && <br/>}</>
                      );
                    })*/}
                  </div>
                </div>
                <div className="columns text-align-right check-availability-button">
                  <button  className="form-action-button mv-button primary" type="button"
                    onClick={() => { this.props.showAvailability(false); this.handleShowAvailability(); }}>{localize("static.content.check-availability")}
                  </button>
                </div>
              </div>
            {/* {
              this.props.result.unavailable && this.props.result.unavailable.length > 0 && 
                <div className="points top-dashed-border room-types-section">
                  <div className="nine columns points">
                    <p style={{fontWeight:"bold", paddingLeft:"4px", color: "#5F5F5F",fontFamily:"Arial" }}>Waitlist Room Type(s): </p>

                    {(this.props.result.unavailable || []).map((room, i) => {
                      return (
                        <span className="rm-type" key={i}>
                          <span>{room.display}</span>
                          { i < this.props.result.unavailable.length - 1 && ' | '}
                        </span>
                      );
                    })}
                  </div>
                  <div className="columns text-align-right">
                    <div className="waitlist-button">
                      <button className="form-action-button mv-button secondary"
                        onClick={() => this.props.showAvailability(true)}>
                        Waitlist
                      </button>
                    </div>
                  </div>
                </div>
            } */}
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <li className="single-results">
          <span className="remove-resort" onClick={this.removeItem}>
            <MvIcon color="rgb(2,150,136)" height="13px" width="13px" icon="x" />
          </span>
          <div className="content">
            {content}
          </div>
        </li>
      </React.Fragment>
    );
  }
}

ResultSingleItem.contextType = LocalizationContext;

export default ResultSingleItem;
